/**
 * The flagship tour is rendered at root-level public URLs. Other tours use a
 * stable, URL-safe first path segment, for example /pine-valley-league.
 */
/**
 * KGA Tour remains the permanent root-level flagship. Deployments can override
 * this value, but the fallback keeps local development functional until Vite
 * is restarted after a new .env value is added.
 */
export const DEFAULT_FLAGSHIP_TOUR_ID = "Y554RbStMKNoxyBPVrgQ";
export const FLAGSHIP_TOUR_ID =
  import.meta.env.VITE_FLAGSHIP_TOUR_ID ?? DEFAULT_FLAGSHIP_TOUR_ID;

export const RESERVED_TOUR_IDS = new Set([
  "admin",
  "schedule",
  "events",
  "players",
  "standings",
  "news",
  "patch-notes",
  "about",
  "rules",
  "achievements",
  "stats",
  "more",
  "play",
  "guest",
  "user-settings",
  "player-settings",
  "tools"
]);

export function isAvailableTourId(tourId: string) {
  return (
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(tourId) && !RESERVED_TOUR_IDS.has(tourId)
  );
}

export function tenantPath(tourId: string, path = "") {
  const normalizedPath = path && !path.startsWith("/") ? `/${path}` : path;
  return `/${encodeURIComponent(tourId)}${normalizedPath}`;
}
